<script setup>
const props = defineProps({
  myNcode: String,
})

const parsedMyNcode = computed(() => {
  const [mbti, alpha] = (props.myNcode || '').split('+')
  return mbti ? mbti.split('') : []
})
const nangmanCode = computed(() => {
  const [, alpha] = (props.myNcode || '').split('+')
  return alpha || ''
})
</script>

<template>
  <div class="ncode-letter">
    <span
      v-for="(char, idx) in parsedMyNcode"
      :key="`mbti-${idx}`"
      :class="`fnt-color-${char}`"
    >
      {{ char }}
    </span>
    <div class="ncode-plus"></div>
    <span
      v-if="nangmanCode"
      class="nangman-code"
      :class="nangmanCode"
    >
      {{ nangmanCode }}
    </span>

  </div>
</template>
<style scoped lang="scss">
  .ncode-plus{
    width: 20px;
    height: 20px;
    aspect-ratio: 1/1;
    background: url('@manseImages/ncode-plus-icon.svg') center center no-repeat;
    background-size: contain;
  }
  .ncode-letter{
    text-align: center;
    font-family: Pretendard;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    .nangman-code{
      display: flex;
      width: 28px;
      height: 28px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      aspect-ratio: 1/1;
      border-radius: 40px;
      background: var(--black-100, #404040);
      color: var(--gray-100-white, #FFF);
      text-align: center;
      font-family: Pretendard;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      &.B {
        background: var(--black-100, #404040);
      }
      &.R {
        background: var(--red, #C23535);
      }
      &.G {
        background: var(--green, #5E9F1C);
      }
      &.Y {
        background: var(--yellow, #DB9823);
      }
      &.W{
        background: var(--gray-500, #949494);
      }
    }
  }
</style>